module.exports = __webpack_public_path__ + "img/icon-loader.4e3f53c1.svg";